import { render, staticRenderFns } from "./waitHandleOrder.vue?vue&type=template&id=662c7a5e&scoped=true&"
import script from "./waitHandleOrder.js?vue&type=script&lang=js&"
export * from "./waitHandleOrder.js?vue&type=script&lang=js&"
import style0 from "./waitHandleOrder.vue?vue&type=style&index=0&id=662c7a5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c7a5e",
  null
  
)

export default component.exports